import { useAppDispatch, useAppSelector } from "@/utils/storage/stores/store";
import { Car } from "../../../../types/Car/Car.interface";
import { RootState } from "../../../../utils/storage/stores/store";
import { selectCar, setIsShownCarSelection } from "../../../../utils/storage/slices/userSlice";

/**
 * Компонент для отображения выбранного автомобиля
 * @param car - объект автомобиля
 * @returns 
 */
export const CurrentCar = () => {
    const selectedCar: Car | null = useAppSelector((state: RootState) => state.user.car);
    const dispatch = useAppDispatch();
    const { brand, model, year, body, engine } = selectedCar || {};

    /** Смена автомобиля */
    const handleChangeCar = () => {
        dispatch(selectCar(null));
    };

    /** Покупка без автомобиля */
    const handleBuyWithoutCar = () => {
        dispatch(selectCar(null));
        dispatch(setIsShownCarSelection(false));
        //TODO: переход на страницу покупки без автомобиля
    };

    return (
        <div className="w-full max-w-5xl mb-6">
            <div className="bg-gray-100 border-t-4 border-orange-500 rounded-lg p-4">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
                    <p className="font-bold text-gray-800 uppercase text-sm mr-4">ВЫБРАН АВТОМОБИЛЬ:</p>
                    <div className="flex-1 flex justify-center">
                        <p className="bg-white rounded-lg p-3 shadow-sm flex items-center gap-3 cursor-pointer hover:shadow-md transition-shadow">
                            <span className="min-w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
                                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path>
                                    <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1V8a1 1 0 00-1-1h-3z"></path>
                                </svg>
                            </span>
                            <span className="text-gray-800 font-medium text-center">
                                {year} {brand} {model} {body} {engine}
                            </span>
                        </p>
                    </div>
                    <div className="flex flex-col gap-2 text-sm items-center">
                        <button className="text-gray-700 underline hover:text-gray-900 transition-colors"
                            onClick={handleChangeCar}>
                            Сменить автомобиль
                        </button>
                        <button className="text-gray-700 underline hover:text-gray-900 transition-colors"
                            onClick={handleBuyWithoutCar}>
                            Покупать без автомобиля
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};